<template>
  <svg :width="width" :height="height" viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.86667 4C7.31513 4 6 5.31092 6 7V71C6 72.6891 7.31513 74 8.86667 74H59.1333C60.6849 74 62 72.6891 62 71V47C62 46.4477 62.4477 46 63 46C63.5523 46 64 46.4477 64 47V71C64 73.7292 61.8528 76 59.1333 76H8.86667C6.1472 76 4 73.7292 4 71V7C4 4.2708 6.1472 2 8.86667 2H59.1333C61.8528 2 64 4.2708 64 7V17C64 17.5523 63.5523 18 63 18C62.4477 18 62 17.5523 62 17V7C62 5.31092 60.6849 4 59.1333 4H8.86667Z"
      fill="#05070F"
    />
    <path
      d="M39 40.5C39 41.3284 38.3284 42 37.5 42C36.6716 42 36 41.3284 36 40.5C36 39.6716 36.6716 39 37.5 39C38.3284 39 39 39.6716 39 40.5Z"
      fill="#05070F"
    />
    <path
      d="M39 44.5C39 45.3284 38.3284 46 37.5 46C36.6716 46 36 45.3284 36 44.5C36 43.6716 36.6716 43 37.5 43C38.3284 43 39 43.6716 39 44.5Z"
      fill="#05070F"
    />
    <path
      d="M39 48.5C39 49.3284 38.3284 50 37.5 50C36.6716 50 36 49.3284 36 48.5C36 47.6716 36.6716 47 37.5 47C38.3284 47 39 47.6716 39 48.5Z"
      fill="#05070F"
    />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M28 11H13V30H28V11ZM11 9V32H30V9H11Z" fill="#05070F" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.5399 23.0225L17.6142 23.2239C16.3655 23.4957 15.4136 23.9576 14.7105 24.5732C14.013 25.1839 13.5153 25.9849 13.2293 27.014C13.1181 27.4139 13.0162 28.1743 12.9462 29.362L12.8905 30.3077L10.999 30.1963L11.0547 29.2505C11.1252 28.0545 11.234 27.1175 11.4037 26.5066C11.779 25.1565 12.4612 24.0243 13.4624 23.1476C14.458 22.2759 15.7237 21.6963 17.2113 21.3726L18.137 21.1711L18.5399 23.0225ZM22.9091 21.1772L23.834 21.3823C26.8012 22.0402 28.791 23.7151 29.5741 26.4251C29.7553 27.052 29.8711 28.0167 29.9461 29.2487L30.0037 30.1943L28.1124 30.3095L28.0549 29.3639C27.9803 28.14 27.8718 27.3592 27.7538 26.9511C27.193 25.0104 25.8261 23.7647 23.4239 23.2321L22.499 23.027L22.9091 21.1772Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.5001 14.9474C18.538 14.9474 16.9475 16.5379 16.9475 18.5C16.9475 20.4621 18.538 22.0526 20.5001 22.0526C22.4622 22.0526 24.0527 20.4621 24.0527 18.5C24.0527 16.5379 22.4622 14.9474 20.5001 14.9474ZM15.0527 18.5C15.0527 15.4915 17.4916 13.0526 20.5001 13.0526C23.5086 13.0526 25.9475 15.4915 25.9475 18.5C25.9475 21.5085 23.5086 23.9474 20.5001 23.9474C17.4916 23.9474 15.0527 21.5085 15.0527 18.5Z"
      fill="#05070F"
    />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M56.5381 14.0794H35.5381V10.0794H56.5381V14.0794Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M50.5381 18.0317H35.5381V16.0317H50.5381V18.0317Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M54.5381 22.1587H35.5381V20.1587H54.5381V22.1587Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M49.5381 26.2857H35.5381V24.2857H49.5381V26.2857Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M55.5381 55.5H35.5381V53.5H55.5381V55.5Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M54.5381 59.627H35.5381V57.627H54.5381V59.627Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M57.5381 63.754H35.5381V61.754H57.5381V63.754Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M55.5381 68H35.5381V66H55.5381V68Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M49.5381 37H35.5381V35H49.5381V37Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M52 41.5H42V39.5H52V41.5Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M55 45.5H42V43.5H55V45.5Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M50 49.5H42V47.5H50V49.5Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M24.5721 37H11.7432V35H24.5721V37Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M27.3329 41H11.7432V39H27.3329V41Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M24.5721 45H11.7432V43H24.5721V45Z" fill="#05070F" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M63 23C58.0294 23 54 27.0294 54 32C54 36.9706 58.0294 41 63 41C67.9706 41 72 36.9706 72 32C72 27.0294 67.9706 23 63 23ZM52 32C52 25.9249 56.9249 21 63 21C69.0751 21 74 25.9249 74 32C74 38.0751 69.0751 43 63 43C56.9249 43 52 38.0751 52 32Z"
      fill="#FF0064"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M54.8848 38.243L70.3463 24.8961L71.6532 26.4101L56.1917 39.757L54.8848 38.243Z"
      fill="#FF0064"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'HiddenProfileIllustration',
  props: {
    width: {
      type: Number,
      default: 78,
    },
    height: {
      type: Number,
      default: 78,
    },
  },
};
</script>
